




















import Vue, { PropType } from 'vue'
import { Agency } from '@/api/Agency/agency.interface'
import { RemittancePrice } from '@/utils/interfaces/remittance.interface'
import ActionButton from '@/components/ActionButton.vue'
export default Vue.extend({
  components: {
    appActionButton: ActionButton,
  },
  props: {
    item: Object as PropType<Agency>,
    getter: Function,
  },
  data() {
    return {
      data: {
        agency: '',
        min_amount: 0,
        max_amount: 0,
        percent: 0,
      } as RemittancePrice,
      loading: false,
    }
  },
  methods: {
    onClick() {
      this.$emit('edit', this.data)
    },
  },
  async mounted() {
    try {
      this.loading = true
      const response = await this.getter({
        agency__uuid: this.item.uuid,
        limit: 1,
      })
      if (response.data.count) {
        this.data = response.data.results[0]
      } else this.data.agency = this.item.uuid
    } finally {
      this.loading = false
    }
  },
})
